import React, { useMemo } from 'react';
import {
    Footer as LayoutComponentFooter,
    useShellContext
} from '@vtblife/layout-components';
import { MenuItemComponentProps } from '@vtblife/layout-components/dist/types/menu-item.interface';
import {
    FooterApp,
    FooterLink,
    FooterMiddleCol,
    FooterPhoneType,
    FooterSocialLink,
} from '@vtblife/layout-components/dist/types/footer.interface';
import { FooterLink as FooterLinkConfig } from '@vtblife/layout-config/dist/types';
import { IconSmallSize, IconMediumSize } from '@vtblife/uikit-icons/dist/types';

import { errorCatcherWrap } from '@search/error/src/catcher';

import { ClShellConfigContext, useCustomConfig } from '../ClShellProvider';

const ALLOWED_SOCIAL_ICONS: ReadonlyArray<IconSmallSize & IconMediumSize> = [ 'vk', 'telegram', 'max' ];

const isAllowedSocialIcon = (icon: string): icon is IconSmallSize & IconMediumSize =>
    ALLOWED_SOCIAL_ICONS.some(allowed => allowed === icon);

const FooterMenuItemComponent: React.FC<MenuItemComponentProps> = props => {
    const { url = '/', path, ...rest } = props;

    return <a key={url} href={url === 'undefined' ? path : url} {...rest} />;
};

const ClFooter: React.FC<{
    buildLink?: (url: string) => string;
    phone?: FooterPhoneType;
    regionId?: number;
}> = ({ regionId, ...props }) => {
    const { config } = useShellContext() as unknown as { config: ClShellConfigContext };

    // Костыль, не работает useShellContext
    const shellConfig = useCustomConfig();

    const effectiveConfig = config ?? shellConfig;

    const { top, middleLinks: rawMiddleLinks, downloadAppQrCode } = effectiveConfig?.footer || {};
    const rawSocialLinks = effectiveConfig?.footer?.socialLinks;
    const rawApps = effectiveConfig?.footer?.apps;

    const socialLinks = useMemo<FooterSocialLink[]>(() => (rawSocialLinks ?? [])
        .filter((link): link is { name: string; icon: IconSmallSize & IconMediumSize; href: string } =>
            link !== null && link !== undefined && isAllowedSocialIcon(link.icon))
        .map(({ name, icon, href }) => ({ name, icon, href }))
    , [ rawSocialLinks ]);

    const apps = useMemo<FooterApp[]>(() => (rawApps ?? [])
        .map(({ href, imgSrc, analytics }) => ({ href, imgSrc, analytics: analytics ?? undefined }))
    , [ rawApps ]);

    const buildLink = (link: FooterLinkConfig) => {
        const url = (link.to || link.href) as string;
        const absoluteUrl = props.buildLink ? props.buildLink(url) : url;

        return {
            ...link,
            href: link.cdn ? url : absoluteUrl
        };
    };

    const topLinks: Array<Array<FooterLink>> = (top || [])
        .map(links => (links || [])
            .map(link => buildLink(link as FooterLinkConfig))
        );

    const middleLinks: Array<FooterMiddleCol> = (rawMiddleLinks || [])
        .map(column => ({
            title: column!.title,
            links: (column!.links || []).map(link => buildLink(link as FooterLinkConfig))
        }));

    return (
        <LayoutComponentFooter
            top={topLinks}
            middle={middleLinks}
            menuItemComponent={FooterMenuItemComponent}
            phone={props.phone}
            socialLinks={socialLinks}
            downloadAppQrCode={downloadAppQrCode ?? ''}
            apps={apps}
        />
    );
};

export default errorCatcherWrap(ClFooter);
